/**
 * Make country data friendly for UI
 * @param {*} data
 * @returns
 */
const formatCountries = (data) => {
  return data.map((country) => ({
    label: country.list_label,
    value: country.alpha2,
    id: country.id,
  }));
};

const formatStates = (data) => {
  return data.map((state) => ({
    label: state.name,
    value: state.id,
  }));
};

function normaliseCountries(countries) {
  return formatCountries(countries);
}

function normaliseStates(states) {
  return formatStates(states);
}

export { normaliseCountries, normaliseStates };
